import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import {
    Text, Styles,
} from "./../../components/UI-Components";
import { Button, Surface } from 'react-native-paper';
import Toaster from './../../components/snackBar_toaster';
import moment from 'moment';
// import { isPastDate, deviceWidth } from './../Utils';
const _width = window.innerWidth;



export const isPastDate = date => moment() > moment(date) 

const testStartTimeFromNow = date => moment(date).fromNow();

export default ({ navigation, data = {} }) => {
    const {
        completed,
        duration,
        end_date_time,
        id,
        image_url,
        material_test_status,
        no_of_questions,
        test_date,
        title,
        start_date_time 
    } = data || {};
    // const showToaster = (msg = '', time = 2000) => this.refs.toast.show(msg, time);
    const showToaster = (msg = '', time = 2000) => alert(msg);
    const isTestCompleted = completed || material_test_status === "submitted" || isPastDate(end_date_time)

    return (
        <div className='material_test_component'>
            <Surface style={styles.roundBorder}>
                <View style={{ justifyContent: 'center', flex: 1 }}>
                    <Image
                        style={styles.imageRes}
                        source={{ uri: image_url }}
                        resizeMode="cover"
                    />
                </View>
                <View style={[{ flex: 4 }]}>
                    <View style={[styles.flexRow, { marginBottom: 10 }]}>
                        <Text style={{ width: '48%', textAlign: 'right', fontSize: 12, marginRight: 5, fontWeight: '700', ...styles.fontSize }}>Subject :</Text>
                        <Text style={[styles.headingColor, styles.fontSize]}>{title}</Text>
                    </View>
                    <View style={[styles.flexRow, { marginBottom: 10 }]}>
                        <Text style={{ width: '48%', textAlign: 'right', fontSize: 12, marginRight: 5, fontWeight: '700', ...styles.fontSize }}>Questions :</Text>
                        <Text style={[styles.headingColor, styles.fontSize]}>{no_of_questions}</Text>
                    </View>
                    <View style={[styles.flexRow, { marginBottom: 10 }]}>
                        <Text style={{ width: '48%', textAlign: 'right', fontSize: 12, marginRight: 5, fontWeight: '700', ...styles.fontSize }}>Schedule :</Text>
                        <Text ellipsizeMode="tail" numberOfLines={1} style={{ width: '50%', color: Styles.primaryColor, fontWeight: '700', fontSize: _width <= 479 ? 10 : 12 }}>
                            {moment(start_date_time).format('Do MMM hh:mm A') || '-'}
                        </Text>
                    </View>
                    <View style={[styles.flexRow, { marginBottom: 10 }]}>
                        <Text style={{ width: '48%', textAlign: 'right', fontSize: 12, marginRight: 5, fontWeight: '700', ...styles.fontSize }}>Duration :</Text>
                        <Text style={[styles.headingColor, styles.fontSize]}>{duration || ''}
                            <Text style={{ fontSize: 12, marginRight: 5, fontWeight: '700', ...styles.fontSize }}> Minutes</Text>
                        </Text>
                    </View>
                </View>
            </Surface>
            <View style={{ alignItems: 'center' }}>
                {
                    isTestCompleted ?
                        <Button
                            onPress={() => navigation.push('/ShowResults', {
                                testId: id,
                                isMaterialTest: true
                            })}
                            mode='contained'
                            style={[styles.button, { backgroundColor: Styles.dangerColor, width: '40%', borderRadius: 20, marginTop: 20 }]}
                        >
                            Result
                        </Button>
                        :
                        <Button
                            onPress={() => {
                                if (moment(test_date) > moment()) {
                                    const remainigTime = testStartTimeFromNow(test_date);
                                    showToaster(`Test starts ${remainigTime}`)
                                    return
                                };
                                if (isPastDate(end_date_time)) return showToaster('Test Expired');
                                navigation.push('/TestTerms', { testId: id, isMaterialTest: true })
                            }}
                            mode='contained'
                            style={[styles.button, { backgroundColor: 'green', width: '75%', borderRadius: 20, marginTop: 20 }]}
                        >
                            START
                    </Button>
                }
            </View>

            {/* <Toaster ref='toast' /> */}
        </div>
    )
}


const styles = StyleSheet.create({
    fontSize: {
        fontSize: _width <= 479 ? 10 : 12
    },
    roundBorder: {
       flex: 1,
        flexDirection: 'row',
        marginTop: 15,
        marginHorizontal: 20,
        paddingVertical: 30,
        // borderWidth:0.4,
        // borderColor: '#222',
        padding: 15,
        elevation: 9,
        borderRadius: 10,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center'
    },
    flexRow: {
        flexDirection: 'row',
        // justifyContent: 'center',
        // alignItems: 'center',
    },
    headingColor: {
        color: Styles.primaryColor,
        width: '50%',
        fontWeight: '700'
    },
    imageRes: {
        width: 100,
        height: 100
    },
})
